// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import { setupVant } from './plugins/vant';
import router from './router';

const app = createApp(App);
setupVant(app);
app.use(router);
app.mount('#app');
